import { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { FLOATING } from '@/constants/testIds';

export const FloatingCall = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const onScroll = () => setVisible(window.scrollY > 400);
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<a
			href="tel:+13072224082"
			data-testid={FLOATING.callButton}
			aria-label="Call Breakdownexperts now"
			className={`md:hidden fixed left-4 right-4 bottom-4 z-40 btn-red !justify-center !py-4 !px-6 text-base pulse-ring transition-all duration-300 ${
				visible
					? 'translate-y-0 opacity-100'
					: 'translate-y-6 opacity-0 pointer-events-none'
			}`}
		>
			<Phone className="w-5 h-5" strokeWidth={2.5} />
			Call Now — (307) 222-4082
		</a>
	);
};

export default FloatingCall;
